/**
 * Normalización de payload GAS → forma plana usada por la UI.
 * No recalcula KPIs: solo aplana envelopes anidados.
 * @module-isolated analytics-leads
 */
export function normalizeLeadsPayload(raw) {
  let data = raw;
  if (
    data &&
    data.data &&
    typeof data.data === 'object' &&
    data.kpis == null &&
    (data.data.kpis != null || data.data.funnel != null)
  ) {
    data = Object.assign({}, data.data, {
      success: data.success,
      warnings: data.warnings || data.data.warnings || [],
      generatedAt: data.generatedAt || data.data.generatedAt,
      filters: data.filters || data.data.filters
    });
  }
  return data || null;
}
